<template>
    <div class="common-usetool">
        <view class="toptitle">
          <titleColor :title="asd" />
        </view>
        <view class="common-bottom">
          <view v-for="item in toolList" :key="item.id" class="common-item"  @mouseover="toolChose(item.id)" :class="{'common-itemChose': toolListId === item.id}">
            <img :src="item.id===toolListId ? item.choseIcon : item.icon" alt="" >
            <text>{{ item.name }}</text>
          </view>
        </view>
    </div>
</template>

<script>
import titleColor from '@/components/titleColor.vue'
export default {
  components: {
    titleColor,
  },
  data() {
    return {
      toolList: [
        {
          id: 1,
          name: '机场查询',
          icon: require('@/assets/toolimage/black1.png'),
          choseIcon: require('@/assets/toolimage/white1.png')
        },
        {
          id: 2,
          name: '码头查询',
          icon: require('@/assets/toolimage/black2.png'),
          choseIcon: require('@/assets/toolimage/white2.png')
        },
        {
          id: 3,
          name: '船公司',
          icon: require('@/assets/toolimage/black3.png'),
          choseIcon: require('@/assets/toolimage/white3.png')
        },
        {
          id: 4,
          name: '航空公司',
          icon: require('@/assets/toolimage/black4.png'),
          choseIcon: require('@/assets/toolimage/white4.png')
        },
        {
          id: 5,
          name: '计算器',
          icon: require('@/assets/toolimage/black5.png'),
          choseIcon: require('@/assets/toolimage/white5.png')
        },
        {
          id: 6,
          name: 'H.S编码',
          icon: require('@/assets/toolimage/black6.png'),
          choseIcon: require('@/assets/toolimage/white6.png')
        },
      ],
      toolListId: 1,
      asd: '常用工具',
    }
  },
  methods: {
    toolChose(id) {
      // console.log(id);
      this.toolListId = id;
    }
  }
}
</script>
<style scoped lang="scss">
.common-usetool {
  width: 1400px;
  height: 304px;
  background-color: white;
  margin-top: 24px;
  margin-bottom: 48px;
  padding-left: 24px;
  padding-top: 24px;
  .toptitle{
  }
  .common-bottom{
    display: flex;
    font-size: 24px;
    line-height: 36px;
    margin-top: 20px;
    .common-item{
      height: 200px;
      width: 260px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 24px;
      background: #F1F6FF;
      color: #001B51;
      display: flex;
      img{
        width: 80px;
        height: 80px;
      }
    }
    .common-itemChose{
      height: 200px;
      width: 260px;
      flex-direction: column;
      align-items: center;
      background: #001B51;
      color: #ffffff;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
